export enum VariantDeliveryMethodEnum {
  online = 1,
  offline = 2,
}

export enum TemplateType {
  CFET = "CFET",
  SA = "SA",
  ISQ = "ISQ",
  None = "None",
}
export enum BrandingTypeEnum {
  none = 0,
  CFEPOnly = 1,
  Cobranding = 2,
  WhileLabelling = 3,
}

export const BRANDING_TYPE_DESCRIPTION = {
  [BrandingTypeEnum.none]: "None",
  [BrandingTypeEnum.CFEPOnly]: "CFEP Only",
  [BrandingTypeEnum.Cobranding]: "Cobranding",
  [BrandingTypeEnum.WhileLabelling]: "White Labelling",
};

export enum FormTemplateStatus {
  Draft = 1,
  Archived = 2,
  Published = 3,
  All = 4,
  Active = 5,
}
